import clsx from 'clsx';

import { RankByLabels, TableHeaderInterface } from '@/types/aprRankings.types';
export const RANK_BY_FILTER_OPTIONS = [
  { label: RankByLabels.WORLD, value: 'world' },
  { label: RankByLabels.WEEKS_52, value: '52weeks' },
] as const;

export const ADULT_AGE_CATEGORIES = [
  { label: 'All', value: [] },
  { label: '17-19', value: [17, 19] },
  { label: '20-24', value: [20, 24] },
  { label: '25-29', value: [25, 29] },
  { label: '30-34', value: [30, 34] },
  { label: '35-39', value: [35, 39] },
  { label: '40-44', value: [40, 44] },
  { label: '45-49', value: [45, 49] },
  { label: '50-54', value: [50, 54] },
  { label: '55-59', value: [55, 59] },
  { label: '60-64', value: [60, 64] },
  { label: '65-69', value: [65, 69] },
  { label: '70-74', value: [70, 74] },
  { label: '75-79', value: [75, 79] },
  { label: '80-84', value: [80, 84] },
  { label: '85+', value: [85, 120] },
] as const;

export const JUNIOR_AGE_CATEGORIES = [
  { label: 'All', value: [] },
  { label: '12 & under', value: [0, 12] },
  { label: '14 & under', value: [0, 14] },
  { label: '16 & under', value: [0, 16] },
] as const;

export const ADULT_STATS_BUTTONS = [
  { label: `Women's Doubles`, value: '4' },
  { label: `Women's Mixed`, value: '7' },
  { label: `Women's Singles`, value: '1' },
  { label: `Men's Doubles`, value: '5' },
  { label: `Men's Mixed`, value: '6' },
  { label: `Men's Singles`, value: '2' },
];

export const JUNIOR_STATS_BUTTONS = [
  { label: `Girls Doubles`, value: '4' },
  { label: `Girls Mixed`, value: '7' },
  { label: `Girls Singles`, value: '1' },
  { label: `Boys Doubles`, value: '5' },
  { label: `Boys Singles`, value: '2' },
  { label: `Boys Mixed`, value: '6' },
];

export const ADULT_WORLD_STATS_BUTTONS = [
  { label: `Women's`, value: 'F' },
  { label: `Men's`, value: 'M' },
];

export const JUNIOR_WORLD_STATS_BUTTONS = [
  { label: 'Girls', value: 'F' },
  { label: 'Boys', value: 'M' },
];

export const WEEKS_52_TABLE_HEADERS: TableHeaderInterface[] = [
  { label: 'Rank', sticky: true, width: 'w-20' },
  { label: 'Name', sticky: true, width: 'w-[296px]' },
  { label: 'Ranking points', width: 'w-[120px]' },
  { label: 'Age', width: 'w-[120px]' },
  { label: 'Country', width: 'w-[120px]' },
  { label: 'Tournaments', width: 'w-[120px]' },
  { label: 'Matches (W-L)', width: 'w-[120px]', tooltip: true },
  { label: 'Games (W-L)', width: 'w-[120px]', tooltip: true },
  { label: 'Points (E-A)', width: 'w-[120px]', tooltip: true },
];

export const WORLD_RANKING_TABLE_HEADERS: TableHeaderInterface[] = [
  { label: 'World Rank', sticky: true, width: 'w-20' },
  { label: 'Country Rank', width: 'w-20' },
  { label: 'State Rank', width: 'w-20' },
  { label: 'Name', width: 'w-[256px]' },
  { label: 'Ranking Points', width: 'w-[120px]' },
  { label: 'Age', width: 'w-[120px]' },
  { label: 'Tournaments', width: 'w-[120px]' },
  { label: 'Matches (W-L)', width: 'w-[120px]', tooltip: true },
  { label: 'Games (W-L)', width: 'w-[120px]', tooltip: true },
  { label: 'Points (E-A)', width: 'w-[120px]', tooltip: true },
];

export const PLAYER_RANKINGS_OPTIONS = [
  { label: 'Adult Rankings', value: 'adult' },
  { label: 'Junior Rankings', value: 'junior' },
];

const SKELETON_COMMON_CLASS = 'border-r border-t border-gray-200 p-3 h-[72px]';

export const WORLD_RANKINGS_SKELETON_CELLS = [
  { width: 'w-12', className: SKELETON_COMMON_CLASS },
  { width: 'w-12', className: SKELETON_COMMON_CLASS },
  { width: 'w-12', className: SKELETON_COMMON_CLASS },
  { width: 'w-[300px]', className: SKELETON_COMMON_CLASS },
  { width: 'w-[90px]', className: SKELETON_COMMON_CLASS },
  { width: 'w-[90px]', className: SKELETON_COMMON_CLASS },
  { width: 'w-[90px]', className: SKELETON_COMMON_CLASS },
  { width: 'w-[90px]', className: SKELETON_COMMON_CLASS },
  { width: 'w-[90px]', className: SKELETON_COMMON_CLASS },
  { width: 'w-[90px]', className: clsx('border-r-0', SKELETON_COMMON_CLASS) },
];

export const WEEKS_52_SKELETON_CELLS = [
  { width: 'w-6', className: SKELETON_COMMON_CLASS },
  { width: 'w-20', className: SKELETON_COMMON_CLASS },
  { width: 'w-12', className: SKELETON_COMMON_CLASS },
  { width: 'w-8', className: SKELETON_COMMON_CLASS },
  { width: 'w-8', className: SKELETON_COMMON_CLASS },
  { width: 'w-6', className: SKELETON_COMMON_CLASS },
  { width: 'w-16', className: SKELETON_COMMON_CLASS },
  { width: 'w-16', className: SKELETON_COMMON_CLASS },
  { width: 'w-16', className: clsx('border-r-0', SKELETON_COMMON_CLASS) },
];

export const TOURNAMENT_SKELETON_CELLS = [
  { width: 'w-20', className: SKELETON_COMMON_CLASS },
  { width: 'w-[260px]', className: SKELETON_COMMON_CLASS },
  { width: 'w-30', className: SKELETON_COMMON_CLASS },
  { width: 'w-30', className: SKELETON_COMMON_CLASS },
  { width: 'w-30', className: SKELETON_COMMON_CLASS },
  { width: 'w-30', className: SKELETON_COMMON_CLASS },
  { width: 'w-30', className: SKELETON_COMMON_CLASS },
  { width: 'w-30', className: SKELETON_COMMON_CLASS },
  { width: 'w-30', className: SKELETON_COMMON_CLASS },
  { width: 'w-30', className: SKELETON_COMMON_CLASS },
  { width: 'w-30', className: clsx('border-r-0', SKELETON_COMMON_CLASS) },
];

export type PLAYER_RANKING_DROPDOWN_TYPE =
  | ''
  | 'playerSearch'
  | 'rankBy'
  | 'country'
  | 'state'
  | 'age';

export const APR_PAGE_SIZE = '10';
export const APR_PER_PLAYER_PAGE_SIZE = '5';

export const DEFAULT_GROUP_TYPE = 'Amateur';
export const DEFAULT_RANKINGS = 'adult';
export const DEFAULT_PLAYER_AGE = 'all';
export const DEFAULT_RANK_BY = 'world';
export const DEFAULT_STATS_TYPE = '4';
export const DEFAULT_GENDER_TYPE = 'F';

export const TOURNAMENT_TABLE_HEADERS = (
  countryStateTitle: string = 'State',
  isCurrentYearFilterSelected: boolean = false
) => {
  const headers: TableHeaderInterface[] = [
    { label: 'Rank', sticky: true, width: 'w-[80px]' },
    { label: 'Tournament Name', sticky: true, width: 'w-[240px]' },
    { label: 'Strength', width: 'w-[100px]' },
    { label: 'Top', width: 'w-[80px]' },
    { label: '𝑥 of avg', width: 'w-[100px]' },
    { label: 'Date', width: 'w-[120px]' },
    { label: 'Year', width: 'w-[80px]' },
    { label: 'Country', width: 'w-[100px]' },
    { label: `${countryStateTitle}`, width: 'w-[100px]' },
    { label: 'Events', width: 'w-[80px]' },
    { label: 'Players', width: 'w-[76px]' },
  ];

  if (isCurrentYearFilterSelected) {
    headers.splice(1, 0, {
      label: '52 Weeks Rank',
      sticky: true,
      width: 'w-[100px]',
    });
  }

  return headers;
};

export const FILTER_KEYS = {
  SEARCH: 'search',
  COUNTRY: 'country',
  STATE: 'state',
  YEAR: 'year',
} as const;

export const DROPDOWN_FILTER_KEYS = {
  TOURNAMENT_SEARCH: 'tournamentSearch',
  COUNTRY: 'country',
  STATE: 'state',
  YEAR: 'year',
} as const;

export const AGE_API_MAP: Record<string, string> = {
  '0-12': '12u',
  '0-14': '14u',
  '0-16': '16u',
  '85-120': '85o',
};
